import { HttpRequest, httpErrorHandler } from "../../handler"

export default {
  namespaced: true,
  state: {
    voucherHistory: { pageMeta: {}, data: [] },
  },
  mutations: {
    setVoucherHistory(state, payload) {
      state.voucherHistory = payload
    },
  },
  actions: {
    async getVoucherHistory(context, payload) {
      const query = payload
      const url = 'claimVoucherHistory'
      const { success, result, message } = await HttpRequest.authorizedRequest(url, 'GET', {}, { ...query }, {})
      if (success) {
        context.commit('setVoucherHistory', result)
      } else {
        httpErrorHandler(message)
      }
    },
  }
}